import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import ActivityItem from "./activity_item";
import TextureManager from "../../../../manager/texture_manager";
import Utility from "../../../../utility/utility";
import LoaclStorage from "../../../../manager/local_storage";
import ModelData from "../../../public/model_data";
import ActivityUtil, { ActivityCode } from "./activity_util";
import { RedPointModule } from "../../../public/component/redpoint_component";
import LanguageManager from "../../../../manager/language_manager";
import CustomUIStateSwitcher from "../../../public/ui/custom_ui_state_switcher";
import ModuleManager from "../../../../framework/core/module_manager";
import SceneManager from "../../../../manager/scene_manager";

const { ccclass, property } = cc._decorator;
@ccclass
export default class ActivityView extends ViewBase {

    @property([cc.Toggle])
    toggleTopList: cc.Toggle[] = []

    @property([cc.Node])
    nodeToggleRedPointList: cc.Node[] = []

    @property(cc.ScrollView)
    itemListScrollView: cc.ScrollView = null

    @property(cc.Node)
    itemListView: cc.Node = null

    @property(cc.Node)
    nodeItemListConent: cc.Node = null

    @property(ActivityItem)
    prefab_item: ActivityItem = null

    @property(cc.Sprite)
    spriteContent: cc.Sprite = null

    @property(cc.Label)
    labelContent: cc.Label = null

    @property(cc.Button)
    buttonGet: cc.Button = null

    @property(CustomUIStateSwitcher)
    getBtnUiStateSwitcher: CustomUIStateSwitcher = null

    @property(cc.Node)
    nodeGetBtnGray: cc.Node = null

    @property(cc.Node)
    nodeGoBindBtn: cc.Node = null

    @property(cc.Node)
    nodeGettedBtn: cc.Node = null

    @property(cc.Label)
    labelTimeTip: cc.Label = null

    @property(cc.Node)
    nodeLeft: cc.Node = null

    @property(cc.Node)
    nodeRight: cc.Node = null

    @property(cc.Node)
    nodeEmpty: cc.Node = null

    @property(cc.Label)
    labelEmpty: cc.Label = null

    @property(cc.Node)
    nodeBindEffect: cc.Node = null

    @property(cc.Node)
    nodeGoTuiGuangBtn: cc.Node = null

    get curData(){
        return this.m_curData
    }

    protected m_topToggleIndex: number = -1
    protected m_lastSelectIndexMap: number[] = [0, 0]
    protected m_listDataMap: any[] = []
    protected m_lastData: any = null
    protected m_curData: any = null
    protected m_list: ListView = null
    protected m_redPointData = null
    onLoad(){
        let self = this
        let list: ListView = new ListView({
            scrollview: this.itemListScrollView,
            view: this.itemListView,
            content: this.nodeItemListConent,
            item_prefab: this.prefab_item.node,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 1,
            row: 5,
            gap_y: 4,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
        this.eventBind('click_activity_item', function(data){
            let dataList = self.get_list_data()
            for (let index = 0; index < dataList.length; index++) {
                const mailData = dataList[index];
                if(data == mailData){
                    self.m_list.select_item(index)                    
                    return
                }
            }
        })

        for (let index = 0; index < this.toggleTopList.length; index++) {
            const toggle = this.toggleTopList[index];
            let tmpIndex = index
            toggle.node.on('click', function(){
                Utility.playButtonSound();
            })
            toggle.node.on('toggle', function (event: cc.Toggle) {
                if(toggle.isChecked)
                {                    
                    let lastTopIndex = self.m_topToggleIndex
                    self.m_topToggleIndex = tmpIndex                       
                    self.itemListScrollView.stopAutoScroll()
                    if(!self.refreshItemsPanel(self.get_list_data())){
                        let tmpToggle = self.toggleTopList[lastTopIndex]
                        tmpToggle.check()
                    }else{
                        
                    }
                }            
            })
        }
    }

    showTopToggles(list: number[]){
        for (let index = 0; index < this.toggleTopList.length; index++) {
            const element = this.toggleTopList[index];
            element.node.active = false
        }
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            this.toggleTopList[element].node.active = true
        }
    }

    showPanel(data){
        this.m_curData = null
        this.m_listDataMap = data.listDataMap
        let keyList = []
        for (let i = 0; i < data.listDataMap.length; i++) {
            const dataList = data.listDataMap[i];
            for (let j = 0; j < dataList.length; j++) {
                const element = dataList[j];
                let key = ActivityUtil.get_hide_red_point_key(i, element)
                keyList.push(key)
                let hideRedPoint = ActivityUtil.getHideRedPointData(key)
                element.hideRedPoint = hideRedPoint
                if(i == 0){
                    element.nextReceiveTimestamp = Math.ceil(Date.now() * 0.001 + element.nextReceiveSencod)
                }                
            }            
        }
        this.checkRedPointData()
        ActivityUtil.cleanUnusedRedPointData(keyList)
        if(this.m_topToggleIndex < 0){
            this.m_topToggleIndex = data.topIndex || 0
        }else{
            this.m_topToggleIndex = data.topIndex == null ? this.m_topToggleIndex: data.topIndex
        }
        
        this.m_lastSelectIndexMap = data.selectIndexMap || this.m_lastSelectIndexMap
        this.selectTopToggle(this.m_topToggleIndex)
    }

    selectTopToggle(topIndex: number){
        var group = this.toggleTopList[0].toggleGroup || this.toggleTopList[0]['_toggleContainer'];
        group.allowSwitchOff = true
        for (let index = 0; index < this.toggleTopList.length; index++) {
            const element = this.toggleTopList[index];
            element.uncheck()
        } 
        group.allowSwitchOff = false
        this.toggleTopList[topIndex].check()  
    }

    refreshItem(data, index){
        this.m_list.refresh_item(index, data)
    }

    set_last_index(index, topIndex?: number){
        if(topIndex == null){
            topIndex = this.m_topToggleIndex
        }
        this.m_lastSelectIndexMap[topIndex] = index
    }

    get_top_toggle_index(){
        return this.m_topToggleIndex
    }

    get_last_index(topIndex?: number): number{
        if(topIndex == null){
            topIndex = this.m_topToggleIndex
        }
        return this.m_lastSelectIndexMap[topIndex]
    }

    protected get_list_data(topIndex?: number){
        if(topIndex == null){
            topIndex = this.m_topToggleIndex
        }
        return this.m_listDataMap[topIndex]
    }

    protected on_item_select(data: any, index: number){
        let lastIndex = this.get_last_index()
        if(lastIndex >= 0){
            let lastData = this.get_list_data()[lastIndex]
            lastData.selected = false
            this.refreshItem(lastData, lastIndex)
        } 
        data.selected = true  

        let key = ActivityUtil.get_hide_red_point_key(this.m_topToggleIndex, data)
        data.hideRedPoint = true
        ActivityUtil.setHideRedPointData(key)

        this.checkRedPointData()

        for (let i = 0; i < this.nodeToggleRedPointList.length; i++) {
            const element = this.nodeToggleRedPointList[i];
            let dataList = this.m_listDataMap[i]
            let allHideRedPoint = true
            if(dataList){
                for (let j = 0; j < dataList.length; j++) {
                    const tmpData = dataList[j];
                    if(!tmpData.hideRedPoint || tmpData.isReceive){
                        allHideRedPoint = false
                        break
                    }
                }
            }            
            element.active = false && !allHideRedPoint
        }

        this.refreshItem(data, index)                     
        this.set_last_index(index)
        this.refreshDetailPanel(this.m_topToggleIndex, data)
        this.eventDispatch('select_activity_item', data, this.m_topToggleIndex, index)
    } 


    protected update_list_item(itemNode: cc.Node, data: any, index: number){
        let item = itemNode.getComponent(ActivityItem)
        item.show(true, data)
    }
    
    protected refreshItemsPanel(dataList?, index?: number, topIndex?: number){
        if(topIndex != null){
            this.m_topToggleIndex = topIndex
        }
        if(!dataList){
            dataList = this.get_list_data()
        }
        this.m_list.set_data(dataList)
        if(dataList && dataList.length > 0){            
            let lastIndex = this.get_last_index()
            if(index || index == 0){
                lastIndex = index
            }            
            this.m_list.scroll_to(lastIndex)
            this.m_list.select_item(lastIndex)
            return true
        }else{
            this.refreshDetailPanel(this.m_topToggleIndex, null)
            return true
        }
    }

    protected refreshDetailPanel(topIndex: number, data){
        if(this.m_curData && this.m_curData == data){
            return
        }
        let lastData = this.m_curData
        if(lastData && lastData._moduleName){
            ModuleManager.instance.hideModule(lastData._moduleName)
        }
        this.m_lastData = lastData
        this.m_curData = data
        if(!data){
            this.showEmptyPanel(true, topIndex)
            this.showActivityDetail(false)
            this.showNoticeDetail(false)
            return
        }
        if(topIndex == 0){
            this.showEmptyPanel(false)
            this.showNoticeDetail(false)
            this.showActivityDetail(true, data)                        
        }else{
            this.showEmptyPanel(false)
            this.showActivityDetail(false)
            this.showNoticeDetail(true, data)            
        }
    }

    protected showEmptyPanel(show: boolean, topIndex?: number){
        this.nodeEmpty.active = !!show
        if(show){
            this.nodeLeft.active = false
            this.nodeRight.active = false
        }else{
            return
        }
        
        let text = ''
        if(topIndex == 0){
            text = LanguageManager.t('activity_activity_empty')
        }else{
            text = LanguageManager.t('activity_notice_empty')
        }
        this.labelEmpty.string = text
    }

    protected showActivityDetail(show: boolean, data?){
        let self = this     
        if(show && data._moduleName){
            ModuleManager.instance.showModuleName(data._moduleName, data)
            this.nodeLeft.active = true
            show = false
        }  
        if(show){
            this.nodeLeft.active = true
            this.nodeRight.active = true
            
            this.getBtnUiStateSwitcher.SwitchState(data.activityCode)   
            if(data.activityCode == ActivityCode.day_welfare){                
                if(data.isFinish){
                    this.setGetBtnGrayAndDisable(false, true)
                }else{
                    this.setGetBtnGrayAndDisable(true, !data.isReceive)
                    if(!data.isReceive){
                        self.labelTimeTip.unscheduleAllCallbacks()
                        let nextReceiveSencod = Math.ceil(data.nextReceiveTimestamp - Date.now() * 0.001)
                        self.refreshTimeLabel(true, nextReceiveSencod, function(){
                            data.isReceive = true
                            self.showActivityDetail(show, data)
                        })
                    }else{
                        this.labelTimeTip.node.active = false
                    }
                }
            }else{
                this.setGetBtnGrayAndDisable(false, false)
                this.buttonGet.node.active = data.isReceive && !data.isFinish
            }   
            self.spriteContent.node.active = false
            TextureManager.instance.getSprite(data.activityDesc, (sprite) => {
                if(self.node && self.m_curData == data){
                    self.spriteContent.node.active = true
                    self.spriteContent.spriteFrame = sprite
                }                   
            }) 
            this.nodeBindEffect.active = data.activityCode == ActivityCode.bind_mobile  
            this.nodeGettedBtn.active = data.activityCode != ActivityCode.day_welfare && !data.isReceive && data.isFinish
            this.nodeGoBindBtn.active = data.activityCode == ActivityCode.bind_mobile && !data.isReceive && !data.isFinish
            this.nodeGoTuiGuangBtn.active = data.activityCode == ActivityCode.bind_parent && !data.isReceive && !data.isFinish
        }else{
            this.nodeBindEffect.active = false
            this.nodeGettedBtn.active = false
            this.nodeGoBindBtn.active = false
            this.nodeGoTuiGuangBtn.active = false
            this.setGetBtnGrayAndDisable(false, false)
            this.spriteContent.node.active = false            
        }
    }

    protected refreshTimeLabel(show: boolean, leftSecs?: number, onTimeEnd?: Function){
        let self = this
        self.labelTimeTip.node.active = !!show
        if(show){
            self.labelTimeTip.string = self.formatTimeDuration(leftSecs)
            if(leftSecs > 0){
                leftSecs--
                self.labelTimeTip.scheduleOnce(function(){
                    self.refreshTimeLabel(show, leftSecs, onTimeEnd)
                }, 1)
            }else{
                onTimeEnd && onTimeEnd()
            }
        }
        
    }

    protected formatTimeDuration(secs: number): string{        
        let hour = Math.floor(secs / 3600)
        let min = Math.floor((secs - hour * 3600) / 60)
        let s = secs - hour * 3600 - min * 60
        let date = new Date(0,0, 0, hour, min, s)
        return date.format('hh:mm:ss')
    }

    protected showNoticeDetail(show: boolean, data?){        
        let self = this
        if(show){
            this.nodeLeft.active = true
            this.nodeRight.active = true
            self.setGetBtnGrayAndDisable(false, false)
            if(data.noticeType == 2){
                this.labelContent.node.parent.active = false
                this.spriteContent.node.active = false
                TextureManager.instance.getSprite(data.content, (sprite) => {
                    if(self.node && self.m_curData == data){
                        self.spriteContent.node.active = true
                        self.spriteContent.spriteFrame = sprite
                    }                   
                })
            }else{
                this.labelContent.node.parent.active = true
                this.labelContent.string = data.content
            }
            this.labelContent.node.targetOff(this)
            this.spriteContent.node.targetOff(this)
            if(data.customeAppField && data.customeAppField != ''){
                let on_click = ()=>{
                    SceneManager.gotoLink(data.customeAppField)
                }
                this.labelContent.node.on('click', on_click, this)
                this.spriteContent.node.on('click', on_click, this)
            }
        }else{
            this.labelContent.node.parent.active = false
            this.spriteContent.node.active = false
        }
    }

    protected setGetBtnGrayAndDisable(show: boolean, gray: boolean){
        this.buttonGet.node.active = show && !gray
        this.nodeGetBtnGray.active = show && !!gray
    }


    protected checkRedPointData(){
        let dataMap = this.m_listDataMap
        let redPointCount = 0
        for (let i = 0; i < dataMap.length; i++) {
            const dataList = dataMap[i];
            for (let j = 0; j < dataList.length; j++) {
                const element = dataList[j];
                if(!element.hideRedPoint || element.isReceive || element.showRedPoint){
                    redPointCount++
                }                              
            }            
        }
        this.eventDispatch('Event_Notify_RedPoint_Change', RedPointModule.Activity, redPointCount)
        this.eventDispatch('Event_Notify_RedPoint_Refresh')
    }
}